import { Switch } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import PiTooltip from "../features/menu/PiTooltip";

interface PiSwitchProps {
  label: string;
  labelLocId?: string;
  tooltipLocId?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (isChecked: boolean) => void;
}

export default function PiSwitch(props: PiSwitchProps) {
  const { label, labelLocId, tooltipLocId, onChange, disabled = false } = { ...props };
  const { t } = useTranslation();

  const onSwitchToggle = (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    if (disabled) return;
    onChange(checked);
  };

  const onClick = () => {
    if (disabled) return;
    onChange(!props.checked);
  };

  const anchor = (
    <button className="font-medium text-[13px] text-creator-text-sub" onClick={onClick} disabled={disabled}>
      {labelLocId ? t(labelLocId) : label}
    </button>
  );

  return (
    <div aria-label="pi-switch-root" className="flex w-full">
      <PiTooltip anchor={anchor} tooltipLocId={tooltipLocId} />
      <div className="ml-auto">
        <Switch
          checked={props.checked}
          onChange={onSwitchToggle}
          disabled={disabled}
          inputProps={{
            "aria-label": labelLocId ? String(t(labelLocId)) : label,
          }}
        />
      </div>
    </div>
  );
}
